<template>
<div class="no-contents">
    <img class="no-contents-img" :src="imgUrl" v-if="imgUrl">
    <span class="profile-no-contents-text">
        <slot></slot>
    </span>
    <button
        v-if="btnText"
        class="profile-add-action-btn"
        @click="$emit('edit:start')"
    >
        <img src="/static/assets/img/proposal/profile_plus_icon.png">
        {{ btnText }}
    </button>
</div>
</template>

<script>
export default {
    props: ['btnText', 'imgUrl'],
};
</script>

<style lang="scss" scoped>
.no-contents {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    justify-content: center;
}

.no-contents-img {
    margin-bottom: 15px;
}
</style>

